export enum EditProductionScheduleItemInPathGroupAction {
  DELETE,
  EDIT,
  DELETE_COMPLETING_PARTIALLY
}
